import React, { useState, useRef, useEffect } from "react";
import DOMPurify from "dompurify";
import { Container, Row, Col, Card, Button, Form } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";

import axios from "axios";

const AddNewNotification = () => {
  const userData = sessionStorage.getItem("user");
  const userObj = userData ? JSON.parse(userData) : {};

  const [subject, setSubject] = useState("");
  const [description, setDescription] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [imageSetName, setImageSetName] = useState("");
  const [imagePath, setImagePath] = useState("");
  const [notificationType, setNotificationType] = useState("");
  const location = useLocation();
  const navigate = useNavigate();

  const fileInputRef = useRef(null);
  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  const convertContentToHTML = (value) => DOMPurify.sanitize(value);

  const uploadImage = async () => {
    if (!selectedFile) return null;

    const formData = new FormData();
    formData.append("file", selectedFile);

    try {
      const response = await axios.post(`${baseUrl}/uploads/upload/`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return response.data.filename;
    } catch (error) {
      console.error("Image upload failed:", error);
      toast.error("Image upload failed");
      return null;
    }
  };
  useEffect(() => {
    if (location.state && location.state.mode === "edit" && location.state.data) {
      const data = location.state.data;
      setSubject(data.subject || "");
      setDescription(data.description || "");
      setNotificationType(data.notification_type || "");
      setImagePath(data.image_path || "");
      setImageSetName(data.image_path ? data.image_path.split("/").pop() : "");
    }
  }, [location]);
  const handleSubmit = async (e) => {
    e.preventDefault();

    let uploadedImageFileName = imagePath; // default to existing one
    if (selectedFile) {
      const uploadedPath = await uploadImage();
      if (!uploadedPath) return;
      uploadedImageFileName = uploadedPath.split("/").pop();
    }

    const isEdit = location.state && location.state.mode === "edit";
    const payload = {
      action: isEdit ? "UPDATE" : "CREATE",
      notification_id: isEdit ? location.state.data.notification_id : null,
      subject,
      description: convertContentToHTML(description),
      school_id: userObj.school_id,
      createdby: userObj.email || "system",
      image_path: uploadedImageFileName || null,
      notification_type: notificationType,
      modifiedby: userObj.email || "system",
      status: "A"
    };

    try {
      await axios.post(`${baseUrl}/notifications/`, payload, {
        headers: { "Content-Type": "application/json" }
      });

      toast.success(isEdit ? "Notification updated successfully" : "Notification added successfully");
      navigate("/notifications"); // or wherever your list page is

    } catch (error) {
      console.error("Submit error:", error);
      toast.error("Failed to submit notification");
    }
  };



  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const validTypes = ["image/jpeg", "image/png", "image/webp", "image/gif"];
      if (!validTypes.includes(file.type)) {
        toast.error("Invalid file type");
        return;
      }
      setSelectedFile(file);
      setImageSetName(file.name);
      setImagePath(URL.createObjectURL(file));
    }
  };

  const handleRemoveFile = () => {
    setSelectedFile(null);
    setImageSetName("");
    setImagePath("");
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  return (
    <Container fluid>
      <div className="pageBody">
        <ToastContainer />
        <Container fluid>
          <Card>
            <Card.Body>
              <h6 className="commonSectionTitle">Add Notification</h6>
              <Form onSubmit={handleSubmit}>
                <Row>
                  <Col xs={12} md={6} lg={4} xxl={3}>
                    <Form.Group controlId="subject">
                      <Form.Label>
                        Subject <span className="requiredStar">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter Subject "
                        value={subject}
                        onChange={(e) => setSubject(e.target.value)}
                        required
                      />
                    </Form.Group>
                  </Col>

                  <Col xs={12} className="mt-3">
                    <Form.Group controlId="description">
                      <Form.Label>
                        Description <span className="requiredStar">*</span>
                      </Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={5}
                        placeholder="Enter Description"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={12} md={6} lg={4} xxl={3} className="mt-3">
                    <Form.Group controlId="notificationType">
                      <Form.Label>
                        Notification Type <span className="requiredStar"></span>
                      </Form.Label>
                      <Form.Select
                        value={notificationType}
                        onChange={(e) => setNotificationType(e.target.value)}

                      >
                        <option value="" disabled hidden>Select Notification Type</option>
                        <option value="A">Attendance</option>
                        <option value="R">Fee Receipt</option>
                        <option value="H">Homework</option>
                        <option value="N">General</option>

                      </Form.Select>
                    </Form.Group>
                  </Col>


                  <Col xs={12} md={6} lg={4} xxl={3} className="mt-3">
                    <Form.Group>
                      <Form.Label>Image Upload</Form.Label>
                      <Form.Control
                        type="file"
                        accept="image/*"
                        ref={fileInputRef}
                        onChange={handleFileChange}
                      />
                      {imageSetName && (
                        <div className="d-flex justify-content-between align-items-center mt-2">
                          <span>{imageSetName}</span>
                          <span
                            onClick={handleRemoveFile}
                            style={{ cursor: "pointer", color: "red" }}
                          >
                            ✖
                          </span>
                        </div>
                      )}
                    </Form.Group>
                  </Col>


                </Row>
                <div className="d-flex justify-content-between mt-3">
                  <div>
                    <Button
                      type="button"
                      variant="primary"
                      className="btn-info clearBtn"
                      onClick={() => {
                        setSubject("");
                        setDescription("");
                        setSelectedFile(null);
                        setImageSetName("");
                        setImagePath("");
                      }}

                    >
                      Reset
                    </Button>
                  </div>
                  <div>
                    <Button
                      type="button"
                      variant="primary"
                      className="btn-danger secondaryBtn me-2"
                      onClick={() => window.history.back()}
                    >
                      Cancel
                    </Button>
                    <Button
                      type="submit"
                      variant="primary"
                      className="btn-success primaryBtn"
                    >
                      Submit
                    </Button>
                  </div>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Container>
      </div>

    </Container>
  );
};

export default AddNewNotification;
